export const creditConstants = {
  CREDITOPTION_REQUEST: 'CREDITOPTION_REQUEST',
  CREDITOPTION_SUCCESS: 'CREDITOPTION_SUCCESS',
  CREDITOPTION_FAILURE: 'CREDITOPTION_FAILURE',
  ASIGNATE_CREDITOPTION_REQUEST: 'ASIGNATE_CREDITOPTION_REQUEST',
  ASIGNATE_CREDITOPTION_SUCCESS: 'ASIGNATE_CREDITOPTION_SUCCESS',
  ASIGNATE_CREDITOPTION_FAILURE: 'ASIGNATE_CREDITOPTION_FAILURE',
  COBRANZA_PAGOS_REQUEST: 'COBRANZA_PAGOS_REQUEST',
  COBRANZA_PAGOS_SUCCESS: 'COBRANZA_PAGOS_SUCCESS',
  COBRANZA_PAGOS_FAILURE: 'COBRANZA_PAGOS_FAILURE',
  GENERAR_DATOS_COBRNZA_UNICO_REQUEST: 'GENERAR_DATOS_COBRNZA_UNICO_REQUEST',
  GENERAR_DATOS_COBRNZA_UNICO_SUCCESS: 'GENERAR_DATOS_COBRNZA_UNICO_SUCCESS',
  GENERAR_DATOS_COBRNZA_UNICO_FAILURE: 'GENERAR_DATOS_COBRNZA_UNICO_FAILURE',
  COBRANZA_COBRO_REQUEST: 'COBRANZA_COBRO_REQUEST',
  COBRANZA_COBRO_SUCCESS: 'COBRANZA_COBRO_SUCCESS',
  COBRANZA_COBRO_FAILURE: 'COBRANZA_COBRO_FAILURE',
  GETUSERS_GOAL_REQUEST: 'GETUSERS_GOAL_REQUEST',
  GETUSERS_GOAL_SUCCESS: 'GETUSERS_GOAL_SUCCESS',
  GETUSERS_GOAL_FAILURE: 'GETUSERS_GOAL_FAILURE',
  REGISTER_USER_GOAL_REQUEST: 'REGISTER_USER_GOAL_REQUEST',
  REGISTER_USER_GOAL_SUCCESS: 'REGISTER_USER_GOAL_SUCCESS',
  REGISTER_USER_GOAL_FAILURE: 'REGISTER_USER_GOAL_FAILURE',
  GETDEPENDENCIES_REQUEST: 'GETDEPENDENCIES_REQUEST',
  GETDEPENDENCIES_SUCCESS: 'GETDEPENDENCIES_SUCCESS',
  GETDEPENDENCIES_FAILURE: 'GETDEPENDENCIES_FAILURE',
  GETCALCULATE_DATAFILE_REQUEST: 'GETCALCULATE_DATAFILE_REQUEST',
  GETCALCULATE_DATAFILE_SUCCESS: 'GETCALCULATE_DATAFILE_SUCCESS',
  GETCALCULATE_DATAFILE_FAILURE: 'GETCALCULATE_DATAFILE_FAILURE',  
}
